import { render, staticRenderFns } from "./LoadingWait.vue?vue&type=template&id=fa12ce44&"
import script from "./LoadingWait.vue?vue&type=script&lang=js&"
export * from "./LoadingWait.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports